module.exports = __webpack_public_path__ + "img/develop.94c61bce.svg";